import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { createMigrate, persistReducer } from 'redux-persist';
import current from './current.reducer';
import locations from './locations/locations.reducer';
import trainers from './trainer.reducer';
import roles from './roles.reducer';
import categoryList from './categoryList/categoryList.reducer';
import { setLocalStorageProviderUUId } from '~/Hooks/useLocalStorage';

export const providerReducer = combineReducers({
  current,
  locations,
  trainers,
  roles,
  categoryList,
});

const migrations = {
  3: (state: any) => {
    setLocalStorageProviderUUId(
      state?.current?.provider?.uuid || state?.availableProviders?.providerList?.[0]?.uuid,
    );
    return state;
  },
};

const providerReducerPersistConfig = {
  key: 'provider-reducer',
  version: 3,
  migrate: createMigrate(migrations, { debug: true }),
  blacklist: ['locations', 'trainers', 'roles', 'checklist', 'payouts', 'current'],
  storage,
};

export default persistReducer(providerReducerPersistConfig, providerReducer);
